import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export type CircleProps = {
  strokeWidth: number;
  size: number;
  percentage: number;
};

export function CircleProgress({ size, strokeWidth, percentage, ...props }: IconProps & CircleProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * Math.PI * 2;
  const arcOffset = circumference * ((100 - percentage) / 100);

  return (
    <Icon viewBox={`0 0 ${size} ${size}`} transform="rotate(-90deg)" boxSize={size} {...props}>
      <Box as="radialGradient" id="greenGradient" cx="0" cy="0" r="1">
        <Box as="stop" stopColor="#4EBF6B" offset="20%" />
        <Box as="stop" stopColor="#216D6B" offset="100%" stopOpacity="0.9" />
      </Box>

      <Box
        as="circle"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="url(#greenGradient)"
        strokeWidth={`${strokeWidth}px`}
        strokeDasharray={circumference}
        strokeDashoffset={arcOffset}
        strokeLinecap="round"
        transitionProperty="stroke-dasharray, stroke"
        transitionDuration="0.6s"
        transitionTimingFunction="linear"
      />
    </Icon>
  );
}
